export function filterByType(filter, data) {
  if (!Array.isArray(data)) return [];

  const now = new Date();
  let startDate;
  let endDate = now;

  switch (filter) {
    case "week":
    // Start of current week (Monday)
    startDate = new Date(now);
    const dayOfWeek = now.getDay(); // Sunday=0, Monday=1, ..., Saturday=6
    const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Adjust for Monday
    startDate.setDate(now.getDate() + mondayOffset);
    break;

    case "pastweek":
      // Start and end of the previous week (Monday to Sunday)
      const today = new Date();
      const currentDay = today.getDay();
      const currentMondayOffset = currentDay === 0 ? -6 : 1 - currentDay;
      const currentWeekStart = new Date(today);
      currentWeekStart.setDate(today.getDate() + currentMondayOffset);

      startDate = new Date(currentWeekStart);
      startDate.setDate(startDate.getDate() - 7); // Previous week's Monday

      endDate = new Date(currentWeekStart); // Previous week's Sunday (one day before current week's Monday)
      endDate.setDate(endDate.getDate() - 1);
      break;

    case "2week":
      startDate = new Date(now);
      startDate.setDate(now.getDate() - 14);
      break;

    case "month":
      startDate = new Date(now.getFullYear(), now.getMonth(), 1); // First day of current month
      break;

    case "3months":
      startDate = new Date(now);
      startDate.setMonth(now.getMonth() - 3);
      break;

    case "6months":
      startDate = new Date(now);
      startDate.setMonth(now.getMonth() - 6);
      break;

    default:
      return data;
  }
  
  startDate.setHours(0, 0, 0, 0); // Midnight
  endDate.setHours(23, 59, 59, 999); // End of day
  return data.filter(item => {
    const itemDate = new Date(item?.created);
    return (
      !isNaN(itemDate) &&
      itemDate >= startDate &&
      itemDate < endDate
    );
  });
}


export function filterByDate(startDate, endDate, data) {
  if (!startDate || !endDate || !Array.isArray(data)) return [];

  const start = new Date(startDate);
  const end = new Date(endDate);

  // Normalize to include full day
  start.setHours(0, 0, 0, 0);
  end.setHours(23, 59, 59, 999);

  if (isNaN(start) || isNaN(end)) return [];

  return data.filter(item => {
    const itemDate = new Date(item?.created);
    return !isNaN(itemDate) && itemDate >= start && itemDate <= end;
  });
}

// Filter Billing By type
export function filterBillingByType(filter, data) {
  if (!Array.isArray(data)) return [];

  const now = new Date();
  let referenceDate;

  // Helper to format date as "Month YYYY"
  const formatMonthYear = date =>
    date.toLocaleString("default", { month: "long", year: "numeric" });

  // Helper to generate a list of "Month YYYY" between two dates
  const getMonthRange = (start, end) => {
    const months = [];
    const temp = new Date(start.getFullYear(), start.getMonth(), 1);
    while (temp <= end) {
      months.push(formatMonthYear(temp));
      temp.setMonth(temp.getMonth() + 1);
    }
    return months;
  };

  switch (filter) {
    case "week": {
      const startOfThisWeek = new Date(now);
      startOfThisWeek.setDate(now.getDate() - now.getDay()); // Sunday

      const endOfThisWeek = new Date(startOfThisWeek);
      endOfThisWeek.setDate(endOfThisWeek.getDate() + 6); // Saturday

      const validMonths = getMonthRange(startOfThisWeek, endOfThisWeek);
      return data.filter(item => validMonths.includes(item?.month));
    }


    case "pastweek": {
      const endOfPastWeek = new Date(now);
      endOfPastWeek.setDate(now.getDate() - now.getDay()); // Start of this week

      const startOfPastWeek = new Date(endOfPastWeek);
      startOfPastWeek.setDate(startOfPastWeek.getDate() - 7);
      const validMonths = getMonthRange(startOfPastWeek, endOfPastWeek);
      return data.filter(item => validMonths.includes(item?.month));
    }

    case "2week": {
      const endDate = new Date(now);
      const startDate = new Date(now);
      startDate.setDate(startDate.getDate() - 14);
      const validMonths = getMonthRange(startDate, endDate);
      return data.filter(item => validMonths.includes(item?.month));
    }

    case "month":
      referenceDate = new Date(now.getFullYear(), now.getMonth(), 1);
      return data.filter(
        item => item?.month === formatMonthYear(referenceDate)
      );

    case "3months":
    case "6months":
      const monthsBack = filter === "3months" ? 3 : 6;
      referenceDate = new Date(now);
      referenceDate.setMonth(now.getMonth() - monthsBack);
      const validMonths = getMonthRange(referenceDate, now);
      return data.filter(item => validMonths.includes(item?.month));

    default:
      return data;
  }
}

// Filter Billing By Date
export function filterBillingByDate(startDate, endDate, data) {
  if (!startDate || !endDate || !Array.isArray(data)) return [];

  const start = new Date(startDate);
  const end = new Date(endDate);

  // Normalize start and end
  start.setDate(1); // First day of start month
  start.setHours(0, 0, 0, 0);
  end.setMonth(end.getMonth() + 1); // Move to first day of next month
  end.setDate(0); // Last day of selected end month
  end.setHours(23, 59, 59, 999);

  const formatMonthYear = date =>
    date.toLocaleString("default", { month: "long", year: "numeric" });

  const getMonthRange = (start, end) => {
    const months = [];
    const temp = new Date(start.getFullYear(), start.getMonth(), 1);
    while (temp <= end) {
      months.push(formatMonthYear(temp));
      temp.setMonth(temp.getMonth() + 1);
    }
    return months;
  };

  const validMonths = getMonthRange(start, end);

  return data.filter(item => validMonths.includes(item?.month));
}
